import React from "react";
import { LotDataByIdTable } from "./lot-data-by-id-table";

const SelectInventory = (props) => {
  const {
    onChangeSelectQR,
    onSubmitQR,
    isEmpty,
    getDataTableProps,
    selectedQR,
    onCloseModalSelectInventory,
  } = props;

  const totalQty = getDataTableProps().data?.reduce((a, b) => a + b.qnt, 0);

  return (
    <div>
      <div className="flex items-center justify-between my-1 pb-[8px] border-b border-b-primary-grey">
        <h1 className="text-[15px] px-5 font-bold">조정 재고 선택</h1>
        <div className="flex items-center">
          <p className="mr-5">※ 조정 수량을 변경할 LOT를 선택해주세요.</p>
          <button
            onClick={onCloseModalSelectInventory}
            className="border mr-2 px-6 py-1 border-button-grey rounded-[4px]"
          >
            취소
          </button>
          <button
            onClick={onSubmitQR}
            className="border mr-5 px-6 py-1 border-primary-blue bg-primary-blue text-white rounded-[4px]"
          >
            선택 완료
          </button>
        </div>
      </div>
      <div className="px-5">
        <div className="border mt-4 py-2 px-4 text-white border-primary-blue bg-primary-blue">
          재고정보 (현재 재고수량 : {totalQty}개)
        </div>
        <div className="max-h-[16rem] overflow-x-auto">
          <LotDataByIdTable
            isEmpty={isEmpty}
            getDataTableProps={getDataTableProps}
            onChangeSelectQR={onChangeSelectQR}
            selectedQR={selectedQR}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectInventory;
